import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = () => ({
  container: {
    display: 'flex',
    height: '50vh',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const ComponentLoading = props => {
  const { classes } = props;
  return (
    <div className={classes.container}>
      <CircularProgress color="primary" />
    </div>
  );
};

export default withStyles(styles)(ComponentLoading);

ComponentLoading.propTypes = {
  classes: PropTypes.object.isRequired,
};
